/* import __COLOCATED_TEMPLATE__ from './jp-smirf-enrollment-failure.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();